module.exports = __webpack_public_path__ + "img/pr-3.2d7bca86.png";